import { Locality } from '../address/locality';
import { City } from '../address/city';
import { State } from '../address/state';
import { CstAddressEntity } from './cst-address-entity';

export class AddressDTO {
    cstAddressEntityId: CstAddressEntity;
    buildingName: string = "";
    streetName: string = "";
    ndIndLocality: Locality;
    locality:string;
    city:string;
    state:string;
    landmark: string = "";
    ndIndCity: City;
    ndIndState: State;
    postalCode: string = "";
    addressTypcode: string;
    apartment: string;
    county: string;
    contactFlag: false;
    country: string;
    primaryFlag: true;
    nixieCode: string;
    latitude: string;
    longitude: string;
    effectiveDate: string;
    expiryDate: string;
    validFlag: true;
    validationErrors: string;
    activeFlag: true;
    label: string;
    contactPref: string;
    createDate: string;
    createUser: string;
    updateDate: string;
    updateUser: string;
    description: string;
    sortOrder: string;
    additionalLocality: string = "";
    iCurrResYrs: string;

    constructor() {
        this.cstAddressEntityId = new CstAddressEntity();
        this.ndIndLocality = new Locality();
        this.ndIndCity = new City();
        this.ndIndState = new State();
    }

}